/**
 * @file Regions.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Thursday, 26th March 2020 4:48:18 pm
 * @copyright 2015 - 2020 SKAT LLC, Delive LLC
 * @flow
 */
import type { Region } from 'skat-js/types'
// $FlowFixMe[untyped-type-import]
import type { LatLngToPixel } from './Map'

import * as React from 'react'
import { FastLayer, Line, Text } from 'react-konva'
import flatten from 'lodash/flatten'

const getRegionData = (coords, bounds, center, zoom, name, latLngToPixel) => {
  const points = coords.map(({ latitude, longitude }) => latLngToPixel([latitude, longitude]))
  const [x, y] = latLngToPixel([center.latitude, center.longitude])

  const [minX, minY] = latLngToPixel([bounds.minLat, bounds.minLng])
  const [maxX, maxY] = latLngToPixel([bounds.maxLat, bounds.maxLng])

  const boundsXY = { minX, minY: maxY, maxX, maxY: minY } // вот не пойму почему Y так себя ведёт?
  return { x, y, points: flatten(points), zoom, name, boundsXY }
}

const RegionLabel = ({ x, y, zoom, title }) => {
  return (<Text fontStyle='bold' x={x} y={y} text={title} />)
}

const RegionView = ({ points, boundsXY, x, y, zoom, name, viewport }) => {
  let shouldRenderLabel = false

  // Не рисуем район если zoom слишком далек от города
  if (zoom < 8) return null

  // Не рисуем район если он за рамками текущего vieport-а
  if (boundsXY.minX < viewport.minX && boundsXY.maxX < viewport.minX) return null
  if (boundsXY.minX > viewport.maxX && boundsXY.maxX > viewport.maxX) return null
  if (boundsXY.minY < viewport.minY && boundsXY.maxY < viewport.minY) return null
  if (boundsXY.minY > viewport.maxY && boundsXY.maxY > viewport.maxY) return null

  const regionWidth = boundsXY.maxX - boundsXY.minX
  const viewportWidth = viewport.maxX - viewport.minX
  if (regionWidth / viewportWidth > 0.4) shouldRenderLabel = true

  return (
    <React.Fragment key={name}>
      <Line
        points={points}
        closed
        strokeWidth={2}
        stroke='white'
        fill='rgba(200,200,200,.3)'
      />

      {shouldRenderLabel ? <RegionLabel x={x} y={y} zoom={zoom} title={name} /> : null}
      {/* <Rect
        x={boundsXY.minX}
        y={boundsXY.minY}
        width={boundsXY.maxX - boundsXY.minX}
        height={boundsXY.maxY - boundsXY.minY}
        fill='rgba(0,0,0, .2)'
      /> */}
    </React.Fragment>
  )
}

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[value-as-type]
const RegionsView = (props: {zoom: number, latLngToPixel: LatLngToPixel, regions: Array<Region>, left: number, top: number, viewport: any }) => {
  const { latLngToPixel, regions, viewport, zoom } = props
  const processedRegions = regions.filter(region => region.area).map((region) => getRegionData(region.area, region.bounds, region.center, zoom, region.name, latLngToPixel))

  return (
    <FastLayer>
      {processedRegions.map((props, index) => <RegionView key={index} {...props} viewport={viewport} />)}
    </FastLayer>
  )
}

export default RegionsView
